export class PregnancyAndBreastfeedingModel {
  public PregnancyAndBreastfeedingId: number;
  public medicineId: number;
  public breastfeedingContent: string;
  public pregnancyContent: string;
}